module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-tinctures-oils-icon-3-226a63cfef3194084257286ce96bb976.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-tinctures-oils-icon-3.svg
 ** module id = 1008
 ** module chunks = 1 75
 **/